exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lightbox[data-v-7f73e274]{position:fixed;top:0;left:0;z-index:9999;width:100%;height:100%;padding:2px;background:rgba(0,0,0,.8);box-sizing:border-box;font-size:0;font-family:Helvetica Neue,Helvetica,Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7f73e274","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./assets/vue/components/images/lightbox.styl
// module id = 524
// module chunks = 0